var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#38a1f3;}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.66 5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -6.66, -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(7 5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M970.072,1145.055v.543a12.11,12.11,0,0,1-.791,4.253,12.643,12.643,0,0,1-2.349,3.875,11.647,11.647,0,0,1-3.836,2.836,12.674,12.674,0,0,1-5.25,1.087,12.451,12.451,0,0,1-3.5-.5,11.993,11.993,0,0,1-3.116-1.394q.5.048,1.031.047a8.671,8.671,0,0,0,2.853-.473,8.974,8.974,0,0,0,2.493-1.323,4.34,4.34,0,0,1-2.493-.862,4.1,4.1,0,0,1-1.511-2.092,4.3,4.3,0,0,0,.791.071,4.506,4.506,0,0,0,1.127-.142,4.281,4.281,0,0,1-2.984-2.28,4.369,4.369,0,0,1-.468-1.879v-.071a4.076,4.076,0,0,0,1.966.544,4.29,4.29,0,0,1-1.4-1.523,4.1,4.1,0,0,1-.515-2.02,4.176,4.176,0,0,1,.575-2.127,12.35,12.35,0,0,0,8.87,4.441,4.837,4.837,0,0,1-.1-.969,4.089,4.089,0,0,1,.576-2.127,4.307,4.307,0,0,1,1.57-1.547,4.19,4.19,0,0,1,2.146-.579,4.274,4.274,0,0,1,1.726.355,4.225,4.225,0,0,1,1.414.992,8.443,8.443,0,0,0,2.733-1.039,4.085,4.085,0,0,1-.731,1.359,4.413,4.413,0,0,1-1.162,1,8.859,8.859,0,0,0,2.493-.685A8.95,8.95,0,0,1,970.072,1145.055Z",
    transform: "translate(-940.23 -1127.849)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7ab778352bb4e69966ef704e574fd85f.svg";
export { ForwardRef as ReactComponent };